<div (click)="onClickElement($event)" class="d-flex w-100 h-100 justify-content-center align-items-center">
  <div class="overflow-hidden w-100" style="min-width: 21em; max-width: 60vw; border-radius: 1em">
    <app-frame-vimeo-live #videoFrame [live]="data.live" [video]="data.video"></app-frame-vimeo-live>
  </div>
</div>
